var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-feature-chip",class:{ 'is-active': _vm.isActive }},[_vm._v(" PRO ")])
}
var staticRenderFns = []

export { render, staticRenderFns }